module.exports = __webpack_public_path__ + "static/support@2x-6e710bd87d17a3bd2bf6910fb67ecff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/enterprise/support@2x.png
// module id = 2574
// module chunks = 168707334958949